import { render, staticRenderFns } from "./LinkFile.vue?vue&type=template&id=ce3f85ba&scoped=true"
import script from "./LinkFile.vue?vue&type=script&lang=js"
export * from "./LinkFile.vue?vue&type=script&lang=js"
import style0 from "./LinkFile.vue?vue&type=style&index=0&id=ce3f85ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../.yarn/__virtual__/vue-loader-virtual-45869d479f/4/.yarn/berry/cache/vue-loader-npm-15.11.1-829412283a-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3f85ba",
  null
  
)

export default component.exports